




































































import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'Footer'
})
export default class Footer extends Vue {
  private show = false

  // 查看平台规则
  clickRule (): void {
    window.open('https://qnimg.zowoyoo.com/10000/gtpw_pop_config/1762237616749_1626.pdf')
  }

  // 查看平台规则
  clickBtn (path: string): void {
    window.open(path)
  }
}
